// @flow
import type { Continents } from "../../../records/Continent"

// check if country is in eu
// on localhost is true
// we use it only for cookie consent
export default function isEurope(country: string, continents: Continents) {
  // for cypress tests - process.env.IS_STAGING do not work
  if (typeof window !== "undefined" && window.SP_GLOBALS && window.SP_GLOBALS.IS_STAGING) {
    return true
  }
  return country === "localhost" || continents.eu.includes(country)
}
